import { withAuthenticationRequired } from "@auth0/auth0-react";
import { PageLoader } from "src/components/PageLoader";
import React, { ComponentType, useMemo } from "react";
import { useSelector } from 'react-redux';
import { getUserPermissions } from "src/redux/reducers/user";
import MessagePage from "src/components/MessagePage";
import notFound from 'src/global/assets/icons/not-found.svg';


import { checkForPermission, hasAnyPermission } from "./permissions/utils";

interface AuthenticationGuardProps {
  component: ComponentType;
  permission?: string;
  anyPermissions?: string[];
}

const Redirecting = () => (
  <div className="page-layout">
    <PageLoader />
  </div>
);

const AuthGuard: React.FC<AuthenticationGuardProps> = ({
  component,
  permission,
  anyPermissions
}) => {

  const permissions = useSelector(getUserPermissions);
  const Component = useMemo(
    () => withAuthenticationRequired(component, { onRedirecting: Redirecting }),
    [component]
  );

  const isAuthorized = anyPermissions
    ? hasAnyPermission(permissions, anyPermissions)
    : checkForPermission(permissions, permission);

  if (!isAuthorized) {
    return <MessagePage
      title={'Lo sentimos, no contás con permisos para ver esta sección.'}
      message={'Comunicate con el equipo de Comercios de MODO para mas información.'}
      buttonText={'Ir a transacciones'}
      buttonTo={'/'}
      imageSrc={notFound}
    />;
  }

  return <Component />;
};

export default AuthGuard;
